export function getMimeTypeFromFileName (fileName) {
  if (!fileName) {
    return 'application/octet-stream'
  }
  const extension = fileName.toLowerCase().split('.').pop()
  const mimeTypes = {
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png'
  }
  return mimeTypes[extension] || 'application/octet-stream'
}

export function detectMimeTypeFromBytes (byteArray) {
  if (!byteArray || byteArray.length < 4) {
    return null
  }
  if (byteArray[0] === 0x25 && byteArray[1] === 0x50 && byteArray[2] === 0x44 && byteArray[3] === 0x46) {
    return 'application/pdf'
  }
  if (byteArray[0] === 0xff && byteArray[1] === 0xd8 && byteArray[2] === 0xff) {
    return 'image/jpeg'
  }
  if (byteArray.length >= 8 &&
    byteArray[0] === 0x89 &&
    byteArray[1] === 0x50 &&
    byteArray[2] === 0x4e &&
    byteArray[3] === 0x47 &&
    byteArray[4] === 0x0d &&
    byteArray[5] === 0x0a &&
    byteArray[6] === 0x1a &&
    byteArray[7] === 0x0a) {
    return 'image/png'
  }
  return null
}
